import { getItemDefaultDisplay } from "features/configuration/GeneralConfiguration/utils";
import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";
import Select from "common/Select/Select";
import { useContext, useEffect, useState } from "react";
import {
  GeneralConfigurationContext,
  ModalItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import { checkSymbolSearch } from "@shared/utils/misc";

const CheckboxItem = ({ item, ...props }: any) => {
  const { editable, useDefaultPopupContainer } = useContext(
    GeneralConfigurationContext
  );
  const {
    itemValue,
    handleItemChange,
    itemName,
    itemOptions,
    overrideComponent,
    uuid,
  } = useConfigurationItem({ item });
  const getSortedOptions = () =>
    itemOptions.slice().sort((a, b) => {
      const aSelected = itemValue.indexOf(a.value) >= 0;
      const bSelected = itemValue.indexOf(b.value) >= 0;
      return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
    });
  const defaultDisplay = getItemDefaultDisplay(item);
  const { inModal } = useContext(ModalItemContext) || {};
  const [selectOpen, setSelectOpen] = useState(false);
  const [sortedOptions, setSortedOptions] = useState(getSortedOptions);

  const options = sortedOptions.map((itemOption) => {
    const { name, value } = itemOption;
    return { label: name, value: value };
  });

  useEffect(() => {
    if (!selectOpen) {
      setSortedOptions(getSortedOptions());
    }
  }, [selectOpen, itemOptions]);

  const extraInfoComponent = (
    <Select
      mode="multiple"
      placeholder={defaultDisplay}
      onChange={handleItemChange}
      maxTagCount={10}
      value={itemValue}
      optionLabelProp="label"
      variant="borderless"
      popupMatchSelectWidth={false}
      style={{
        width: "100%",
        textAlign: props.extraInfoAlignRight ? "end" : "inherit",
      }}
      options={options}
      onOpenChange={(open) => setSelectOpen(open)}
      showSearch={{
        filterOption: (searchValue, option) =>
          checkSymbolSearch(option?.label, searchValue),
      }}
      getPopupContainer={
        uuid && !useDefaultPopupContainer
          ? () => document.getElementById(uuid)!
          : undefined
      }
      disabled={!editable}
      alignRight={props.extraInfoAlignRight}
    />
  );

  const overridePlaceholder = inModal ? null : <span />;
  return (
    <ConfigurationItemRow
      nameComponent={itemName}
      extraInfoComponent={extraInfoComponent}
      overrideComponent={overrideComponent || overridePlaceholder}
      wrapperId={uuid}
    />
  );
};

export default CheckboxItem;
